import styled from '@emotion/styled';
import { Colors } from 'utils';
import PropTypes from 'prop-types';
import device from './device';
const SecondaryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  background: ${(props) =>
    !props.primary ? Colors.transparent : Colors.hoverBackground};
  color: ${(props) => (!props.primary ? Colors.tertiaryColor : Colors.tertiaryHover)};
  border: 2px solid ${(props) =>
    !props.primary ? Colors.transparent : Colors.hoverBackground};
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
  padding: 10px 16px;
  min-width: ${(props) => (props.minWidth ? props.minWidth : '120px')};
  height: 44px;
  font-size: 16px;
  gap: 6px;
  p {
    color: ${(props) => (!props.primary ? Colors.tertiaryColor : Colors.tertiaryHover)} !important;
    padding: 2px 0px 0px 6px !important;
  }
  @media ${device.allMobile} {
    background: ${(props) =>
    !props.primary ? Colors.transparent : Colors.hoverBackground};
    color: ${(props) => (!props.primary ? Colors.tertiaryColor : Colors.tertiaryHover)};
  }
  &:hover {
    background: ${(props) =>
    props.primary ? Colors.transparent : Colors.hoverBackground};
    color: ${(props) => (props.primary ? Colors.tertiaryColor : Colors.tertiaryHover)};
    p {
      color: ${(props) => (props.primary ? Colors.tertiaryColor : Colors.tertiaryHover)} !important;
    }
  }
  &:disabled {
    background: ${Colors.steel};
    color: ${Colors.grey};
    cursor: not-allowed;
  }
`;

export default SecondaryButton;

SecondaryButton.propTypes = {
  primary: PropTypes.bool,
  minWidth: PropTypes.string,
};
